import React, { FC } from "react"

export const TwoIcon: FC = () => (
  <svg
    width="14"
    height="22"
    viewBox="0 0 14 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0400001 20.08C1.86 18.38 3.43 16.95 4.75 15.79C6.07 14.61 7.16 13.57 8.02 12.67C8.9 11.75 9.55 10.89 9.97 10.09C10.39 9.27 10.6 8.36 10.6 7.36C10.6 5.94 10.23 4.9 9.49 4.24C8.77 3.58 7.64 3.25 6.1 3.25C5.02 3.25 4.01 3.45 3.07 3.85C2.13 4.23 1.29 4.71 0.55 5.29V2.05C1.37 1.63 2.3 1.3 3.34 1.06C4.38 0.799999 5.46 0.669999 6.58 0.669999C9 0.669999 10.74 1.2 11.8 2.26C12.88 3.32 13.42 4.84 13.42 6.82C13.42 7.98 13.23 9.02 12.85 9.94C12.49 10.86 11.92 11.79 11.14 12.73C10.38 13.67 9.41 14.68 8.23 15.76C7.05 16.82 5.65 18.07 4.03 19.51H13.66V22H0.0400001V20.08Z"
      fill="white"
    />
  </svg>
)
